import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../../context/AdminSellerRegistrationOB";
import JWTContext from '../../../context/JWTContext';
import { SubmitHandler, useForm, Controller } from "react-hook-form";
import Swal from 'sweetalert2'
import { useUploadSingleFile } from "../../../hooks/useUploadFile";
import { uploadSingleFile } from "../../../services/uploadService";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";


import { GoogleMap, Marker, LoadScript, Autocomplete } from "@react-google-maps/api";

const schema = yup.object({
    businessName: yup.string().required(),
    yearEstablished: yup.number().required(),
    businessRegistrationNumber: yup.string().required(),
    businessCertificate: yup.string().required(),
    sellerId: yup.string().required(),
    catalogue: yup.string().required(),
    name: yup.string().required(),
    email: yup.string().email().required(),
    phone: yup.string().required(),
    address: yup.string().required(),
    latitude: yup.string().required(),
    longitude: yup.string().required()
    // agreement:yup.boolean().oneOf([true], "You must agree")
}).required();

const SellerDocumentVerificationCompany = () => {
    const navigate = useNavigate();

    const containerStyle = {
        width: "100%",
        height: "400px"
    };

    const [mapCenter, setMapCenter] = useState({
        lat: -6.9175,
        lng: 107.6191, 
    });

    const { saveStep, data,  } = useOnboarding();
    const { register: registerAccount } = useContext(JWTContext);

    const [uploading, setUploading] = useState(false);
    const [attachments, setAttachments] = useState(""); // URLs only
    const [SellerIDattachment, setSellerIDattachment] = useState(""); // URLs only
    const [catalogue, setcatalogue] = useState(""); // URLs only
    const fileInputRef = useRef(null);
    const fileInputRefSellerID = useRef(null);
    const cataloguefileInputRef = useRef(null);
    const [position, setPosition] = useState(null);
    const autocompleteRef = useRef(null);
// const [attachments, setAttachments] = useState([]);
// const [SellerIDattachment, setSellerIDattachment] = useState([]);
// const [catalogue, setcatalogue] = useState([]);




    const {
        control,
        register,
        handleSubmit,
        reset,

        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            businessName: data.businessName ?? "",
            yearEstablished: data.yearEstablished ?? 1900,
            businessRegistrationNumber: data.businessRegistrationNumber ?? "",
            businessCertificate: data.businessCertificate ?? "",
            sellerId: data.sellerId ?? "",
            catalogue: data.catalogue ?? "",
            name: data.name ?? "",
            email: data.email ?? "",
            phone: data.phone ?? "",
            address: data.address ?? "",
            latitude:data.latitude ?? "",
            longitude: data.longitude ?? ""



            //userId: data.userId ?? "",
            // businessType: data.businessType ?? "",
            // businessName: data.businessName ?? "",
            // citizenId: data.citizenId ?? "",
            // businessRegistrationNumber: data.businessRegistrationNumber ?? "",
            // businessCertificate: data.businessCertificate ?? "",
            // sellerId: data.sellerId ?? "",
            // catalogue: data.catalogue ?? "",
            // name: data.name ?? "",
            // email: data.email ?? "",
            // description: data.description ?? "",
            // link: data.link ?? "",
            // address: data.address ?? "",
            // businessLatLong: data.businessLatLong ?? "",
            // shippingAddress: data.shippingAddress ?? "",
            // shippingLatLong: data.shippingLatLong ?? "",
            // shippingHandler:data.shippingHandler ??  0,
            // logo: data.logo ?? "",
            // phone: data.phone ?? "",
            // suburb: data.suburb ?? "",
            // postcode: data.postcode ?? "",
            // state: data.state ?? "",
            // timeZoneInfoId: data.timeZoneInfoId ?? "",
            // banner: data.banner ?? "",
            // topBanner: data.topBanner ?? "",
            // contentBanner: data.contentBanner ?? "",
            // currency: data.currency ?? "",
            // bankAccountName: data.bankAccountName ?? "",
            // bankAccountNumber: data.bankAccountNumber ?? "",
            // productCategoryIdList: data.productCategoryIdList ?? "",
            // productDescription: data.productDescription ?? "",
            // numberProduct: data.numberProduct ?? 0,
            // minPriceRange: data.minPriceRange ?? 0,
            // maxPriceRange: data.maxPriceRange ?? 0,
            // addressName: data.addressName ?? "",
            // gender: data.gender ?? 0,
            // idType: data.idType ?? 0,
            // idNumber: data.idNumber ?? "",
            // idImage: data.idImage ?? "",
            // nationality: data.nationality ?? "",
            // birthDate: data.birthDate ?? null,
            // packageId: data.packageId ?? null,
            // bankTransferId: data.bankTransferId ?? null




        }
    });

    const inputClass = (field) =>
        `form-control p-10 ${errors[field] ? "is-invalid" : ""
        }`;

    const inputradioClass = (field) =>
        `form-radio text-18 ${errors[field] ? "is-invalid" : ""
        }`;

    const inputcheckClass = (field) =>
        `form-check mb-0 custom-circular-checkbox ${errors[field] ? "is-invalid" : ""
        }`;

    const onSubmit = (data) => {
        // if (data.agreement) {
            console.log(data);
            saveStep({
                businessName: data.businessName,
                yearEstablished: data.yearEstablished,
                businessRegistrationNumber: data.businessRegistrationNumber,
                businessCertificate: data.businessCertificate,
                sellerId: data.sellerId,
                catalogue: data.catalogue,
                name: data.name,
                email: data.email,
                phone: data.phone,
                address: data.address,
                latitude: data.latitude,
                longitude: data.longitude
            });
            navigate("/admin/shop-information-company"); 
        // } else {
        //     Swal.fire({
        //         title: "Error",
        //         text: "Please accept the terms and conditions.",
        //         icon: "error"
        //     });
        // }

    };

     const onError = (errors) => {
    console.log("FORM ERRORS:", errors);
    };

    const readUserData = () => {
        if (localStorage.getItem('user') == null) {
            navigate("/login")
        }
    }

    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append("pictureFile", file);

            const result = await uploadSingleFile(formData);
            console.log(result.result.result)
            // result = [{ filePath: "..." }]
            // setAttachments(prev => [...prev, result.result.result]);
            setAttachments(prev => result.result.result);

            // OPTIONAL: store in react-hook-form
            setValue("businessCertificate", result.result.result, {
                shouldValidate: true,
                shouldDirty: true
            });

        } catch (err) {
            console.error(err);
            Swal.fire("Upload failed", err?.message || "Unknown error", "error");
        } finally {
            setUploading(false);
            e.target.value = "";
        }
    };

    const handleUploadSellerID = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append("pictureFile", file);

            const result = await uploadSingleFile(formData);
            console.log(result.result.result)
            // result = [{ filePath: "..." }]
            // setAttachments(prev => [...prev, result.result.result]);
            setSellerIDattachment(prev => result.result.result);

            // OPTIONAL: store in react-hook-form
            setValue("sellerId", result.result.result, {
                shouldValidate: true,
                shouldDirty: true
            });

            // console.log("type : " +typeof SellerIDattachment +" is empty? :" + (SellerIDattachment !== "") + " value : " + SellerIDattachment)
            console.log(SellerIDattachment[0]);
        } catch (err) {
            console.error(err);
            Swal.fire("Upload failed", err?.message || "Unknown error", "error");
        } finally {
            setUploading(false);
            e.target.value = "";
        }
    };


    const handleUploadCatalogue = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append("pictureFile", file);

            const result = await uploadSingleFile(formData);
            console.log(result.result.result)
            // result = [{ filePath: "..." }]
            // setAttachments(prev => [...prev, result.result.result]);
            setcatalogue(prev => result.result.result);

            // OPTIONAL: store in react-hook-form
            setValue("catalogue", result.result.result, {
                shouldValidate: true,
                shouldDirty: true
            });

        } catch (err) {
            console.error(err);
            Swal.fire("Upload failed", err?.message || "Unknown error", "error");
        } finally {
            setUploading(false);
            e.target.value = "";
        }
    };

    useEffect(() => {
        readUserData();
        console.log(attachments)
    }, []);


    useEffect(() => {
        if (data.businessCertificate) {
            setAttachments([data.businessCertificate]);
        }
        if (data.sellerId) {
            setSellerIDattachment([data.sellerId]);
        }
        if (data.catalogue) {
            setcatalogue([data.catalogue]);
        }
    }, [data]);

    useEffect(() => {
        console.log(data.latitude +" "+data.longitude)
        if (data.latitude && data.longitude) {
            const lat = Number(data.latitude);
            const lng = Number(data.longitude);

            setPosition({ lat, lng });
            setMapCenter({ lat, lng });

            setValue("latitude", lat);
            setValue("longitude", lng);
        }
    }, [data, setValue]);

    return (
        <div className="document-verification text_quicksand">
            <div className="container">

                <form onSubmit={handleSubmit(onSubmit,onError)}>
                    <div className="text-18 fw-bold text-black mb-30">
                        <span>Business Information</span>
                    </div>


                    <div className="form-group mb-40">
                        <label className="form-label fw-bold mb-10">Business Name <span className="text-danger">*</span></label>
                        <input type="text" className={inputClass("businessName")} {...register("businessName")} placeholder="Enter bussiness name" />
                    </div>
                    <div className="form-group mb-40">
                        <label className="form-label fw-bold mb-10">Year Established <span className="text-danger">*</span></label>
                        <input type="number" className={inputClass("yearEstablished")} {...register("yearEstablished")} min={1900}  placeholder="Enter year established" />
                    </div>
                    <div className="form-group mb-40">
                        <label className="form-label fw-bold mb-10">Bussiness Registration Number <span className="text-danger">*</span></label>
                        <input type="text" className={inputClass("businessRegistrationNumber")} {...register("businessRegistrationNumber")} placeholder="Enter your name" />
                    </div>

                    <div className="mb-30 col-12">
                        <label className="form-label fw-bold">
                            Business Certificate <span className="text-danger">*</span>
                        </label>

                        <div className="d-flex gap-3 overflow-x-auto pb-4 align-items-center">

                            {/* Uploaded previews */}
                            {/* {attachments.map((url, index) => (
                        <div key={index} className="pictureattachmentthumbnail">
                            <img src={url} className="w-100 h-100 rounded" />
                        </div>
                        ))} */}



                            {/* Upload button */}
                            <div
                                className="pictureattachmentthumbnail add_composite d-flex align-items-center justify-content-center border rounded"
                                onClick={() => fileInputRef.current.click()}
                            >
                                {uploading ? (
                                    <img src="/assets/images/icons/gif/konzy.gif" className="w-100 h-100" />
                                ) : (
                                    <div className="text-center">
                                        <img src="/assets/images/icon/uploadfile.png" />
                                        <div className="text-9">Upload File</div>
                                    </div>
                                )}

                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    className="d-none"
                                    //accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf"
                                    accept="image/png,image/jpeg,image/jpg"
                                    onChange={handleUpload}
                                />
                                {/* <input type="hidden" className={inputClass("businessCertificate")} {...register("businessCertificate")} placeholder="Enter your name" /> */}
                            </div>

                            {/* {attachments!="" && (
                            <div className="" style={{width:"107px", height:"107px"}}>
                                <Link to={attachments} className="h-100" >
                                    <img src={attachments} className="w-100 h-100 rounded" />
                                </Link>
                                
                            </div>
                        )} */}
                            {attachments !== "" && (
                                <div className="text-center fw-bold flex-center ms-10" style={{ width: "107px", height: "107px" }}>
                                    <Link to={attachments} className="text-black" target="_blank">
                                        {/* <span>{attachments[0]?.split("/").pop()} </span> */}
                                        {/* <span>{attachments} </span> */}
                                         <img src={attachments} className="w-100 h-100 rounded" />
                                    </Link>

                                </div>
                            )}
                        </div>
                        {errors.businessCertificate && (
                            <small className="text-danger">
                                {errors.businessCertificate.message}
                            </small>
                        )}
                    </div>

                    <div className="mb-30 col-12">
                        <label className="form-label fw-bold">
                            Valid ID of Seller <span className="text-danger">*</span>
                        </label>

                        <div className="d-flex gap-3 overflow-x-auto pb-4">

                            {/* Uploaded previews */}
                            {/* {attachments.map((url, index) => (
                        <div key={index} className="pictureattachmentthumbnail">
                            <img src={url} className="w-100 h-100 rounded" />
                        </div>
                        ))} */}

                            {/* {SellerIDattachment!="" && (
                            <div className="pictureattachmentthumbnail">
                                <img src={SellerIDattachment} className="w-100 h-100 rounded" />
                            </div>
                        )} */}

                            {/* Upload button */}
                            <div
                                className="pictureattachmentthumbnail add_composite d-flex align-items-center justify-content-center border rounded"
                                onClick={() => fileInputRefSellerID.current.click()}
                            >
                                {uploading ? (
                                    <img src="/assets/images/icons/gif/konzy.gif" className="w-100 h-100" />
                                ) : (
                                    <div className="text-center">
                                        {SellerIDattachment[0] !== "" ? (
                                            <div>
                                                <img src="/assets/images/icon/uploadimage.png" />
                                                <div className="text-9">Re Upload File</div>
                                            </div>
                                        ) :
                                            (
                                                <div>
                                                    <img src="/assets/images/icon/uploadimage.png" />
                                                    <div className="text-9">Upload File</div>
                                                </div>
                                            )
                                        }
                                      
                                    </div>
                                )}

                                <input
                                    type="file"
                                    ref={fileInputRefSellerID}
                                    className="d-none"
                                    accept="image/png,image/jpeg,image/jpg"
                                    onChange={handleUploadSellerID}
                                />
                                {/* <input type="hidden" className={inputClass("sellerID")} {...register("sellerID")}  placeholder="Enter your name" /> */}
                            </div>

                          


                            {SellerIDattachment !== "" && (
                                <div className="" style={{ width: "107px", height: "107px" }}>
                                    <Link to={SellerIDattachment} className="h-100" >
                                        <img src={SellerIDattachment} className="w-100 h-100 rounded" />
                                    </Link>

                                </div>
                            )}
                        </div>
                        {errors.sellerId && (
                            <small className="text-danger">
                                {errors.sellerId.message}
                            </small>
                        )}
                    </div>


                    <div className="mb-30 col-12">
                        <label className="form-label fw-bold">
                            Company Logo <span className="text-danger">*</span>
                        </label>

                        <div className="d-flex gap-3 overflow-x-auto pb-4 align-items-center">

                            {/* Uploaded previews */}

                            {/* Upload button */}
                            <div
                                className="pictureattachmentthumbnail add_composite d-flex align-items-center justify-content-center border rounded"
                                onClick={() => cataloguefileInputRef.current.click()}
                            >
                                {uploading ? (
                                    <img src="/assets/images/icons/gif/konzy.gif" className="w-100 h-100" />
                                ) : (
                                    <div className="text-center">
                                        <img src="/assets/images/icon/uploadfile.png" />
                                        <div className="text-9">Upload File</div>
                                    </div>
                                )}

                                <input
                                    type="file"
                                    ref={cataloguefileInputRef}
                                    className="d-none"
                                    // accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf"
                                    accept="image/png,image/jpeg,image/jpg"
                                    onChange={handleUploadCatalogue}
                                />

                            </div>


                            {catalogue !== "" && (
                                <div className="text-center fw-bold flex-center ms-10" style={{ width: "107px", height: "107px" }}>
                                    <Link to={catalogue} className="text-black" target="_blank">
                                        {/* <span>{catalogue} </span> */}
                                         <img src={catalogue} className="w-100 h-100 rounded" />
                                    </Link>

                                </div>
                            )}
                        </div>
                        {errors.catalogue && (
                            <small className="text-danger">
                                {errors.catalogue.message}
                            </small>
                        )}
                    </div>

                    <div className="text-18 fw-bold text-black mb-30">
                        <span>Seller Contact Details</span>
                    </div>

                    <div className="form-group mb-40">
                        <label className="form-label fw-bold mb-10">Full Name <span className="text-danger">*</span></label>
                        <input type="text" className={inputClass("name")} {...register("name")} placeholder="Enter your name" />
                    </div>

                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="form-group ">
                            <label className="form-label fw-bold mb-10">Email <span className="text-danger">*</span></label>
                            <input type="email" className={inputClass("email")} {...register("email")} placeholder="Enter your email" />
                        </div>
                        <div className="form-group composite ">
                            <label className="form-label fw-bold mb-10">Phone Number <span className="text-danger">*</span></label>
                            <Controller
                                name="phone"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <PhoneInput
                                        {...field}
                                        defaultCountry="ID"
                                        international
                                        placeholder="Enter phone number"
                                        className="form-control d-flex"
                                    />
                                )}
                            />

                            {errors.phone && (
                                <span className="text-danger text-sm">
                                    {errors.phone.message}
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="form-group mb-40">
                        <label className="form-label fw-bold mb-10">Address <span className="text-danger">*</span></label>
                        <input type="text" className={inputClass("address")} {...register("address")} placeholder="Enter bussiness Address" />
                    </div>
                    <div className="mb-30">
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
                            // googleMapsApiKey={"AIzaSyDQ-aesOz_ut1yBv_d6FG-0N60uqDwgLZs"}
                            libraries={["places"]}
                        >
                            <Autocomplete
                                onLoad={(autocomplete) => {
                                    autocompleteRef.current = autocomplete;
                                }}
                                onPlaceChanged={() => {
                                    if (!autocompleteRef.current) return;

                                    const place = autocompleteRef.current.getPlace();
                                    if (!place.geometry) return;

                                    const lat = place.geometry.location.lat();
                                    const lng = place.geometry.location.lng();

                                    setMapCenter({ lat, lng });

                                    setValue("latitude", lat, { shouldDirty: true });
                                    setValue("longitude", lng, { shouldDirty: true });
                                }}
                            >
                                <input
                                    type="text"
                                    className="form-control mb-30 d-none"
                                    placeholder="Search business location"
                                />
                            </Autocomplete>

                            <GoogleMap
                                className="mb-30"
                                mapContainerStyle={containerStyle}
                                center={mapCenter}
                                zoom={13}
                                onClick={(e) => {
                                    setPosition({
                                        lat: e.latLng.lat(),
                                        lng: e.latLng.lng(),
                                    });

                                    const lat = e.latLng.lat();
                                    const lng = e.latLng.lng();

                                    // setMapCenter({ lat, lng });

                                    setValue("latitude", lat, { shouldDirty: true });
                                    setValue("longitude", lng, { shouldDirty: true });

                                }}
                            >
                                <Marker position={position} />
                            </GoogleMap>
                        </LoadScript>
                        {errors.latitude && (
                            <span className="text-danger text-sm">
                                {errors.latitude.message}
                            </span>
                        )}
                        {errors.longitude && (
                            <span className="text-danger text-sm">
                                {errors.longitude.message}
                            </span>
                        )}

                    </div>



                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn_mart_primary" onClick={() => navigate("/registration-shop-information")} >Next</button> */}
                        <button className="btn btn_mart_primary" type="submit" >Next</button>
                    </div>
                </form>

            </div>
        </div>
    );
};

export default SellerDocumentVerificationCompany;